import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq, axiosReq2 } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import Cookies from 'universal-cookie';

const AddModalAdmin = ({ setShowModal, title, buttonName, setRecheck, reCheck, data, setSettingModal, setData }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();

    const [supervisor, setSupervisor] = useState();
    useEffect(() => {
        const cookies = new Cookies();

        setSupervisor(cookies.get('supervisor'))

    }, []);
    const [allValues, setAllValues] = useState({
        IsAdmin: data ? data.isAdmin : false,
        IsGozinesh: data ? data.isGozinesh : false,
        IsFace: data ? data.isFace : false,
        IsWordCloud: data ? data.isWordCloud : false,
        IsCreateImage: data ? data.isCreateImage : false,
        Supervisor: data ? data.supervisor : false,
        Chatbot: data ? data.chatbot : false,

        Name: data ? data.name : '',
        Family: data ? data.family : '',
        Username: data ? data.username : '',
        Email: data ? data.email : '',
        PhoneNumber: data ? data.phoneNumber : '',
        Password: data ? data.password : ''

    });
    const [allValuesError, setAllValuesError] = useState({
        Name: false,
        Family: false,
        Username: false,
        Email: false,
        PhoneNumber: false,
        Password: false

    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };


    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateCreateForm = () => {
        const errors = {
            Name: !allValues.Name?.trim(),
            Family: !allValues.Family?.trim(),
            Username: !allValues.Username?.trim(),
            Email: !allValues.Email?.trim() || !emailPattern.test(allValues.Email.trim()),
            PhoneNumber: !allValues.PhoneNumber?.trim(),
            Password: false,
        };
        setAllValuesError(errors);
        return !Object.values(errors).some(Boolean);
    };

    const addAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)

        const fieldsOk = validateCreateForm();
        const passwordOk = allValues.Password && allValues.Password.match(check);

        if (!fieldsOk || !passwordOk) {
            setAllValuesError((prev) => ({
                ...prev,
                Password: !passwordOk,
            }));
            setSnipper(false);
            return;
        }

        const dataUser = await axiosReq("user/InsertUser", "post", {
            IsAdmin: allValues?.IsAdmin,
            Name: allValues?.Name,
            Family: allValues?.Family,
            Username: allValues?.Username?.trim(),
            Email: allValues?.Email?.trim(),
            PhoneNumber: allValues?.PhoneNumber?.trim(),
            Password: allValues?.Password,
            IsGozinesh: allValues?.IsGozinesh,
            IsFace: allValues?.IsFace,
            IsWordCloud: allValues?.IsWordCloud,
            IsCreateImage: allValues?.IsCreateImage,
            Supervisor: allValues?.Supervisor,
            Chatbot: allValues?.Chatbot
        });
        setSnipper(false);
        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            const userConnectId = dataUser?.data?.userConnectId;
            if (userConnectId) {
                try {
                    await axiosReq2("admin/user", "post", {
                        username: userConnectId,
                        user_id: userConnectId,
                    });
                } catch (sarError) {
                    console.warn("Optional SAR user sync failed:", sarError);
                }
            }

            setRecheck(!reCheck);
            setShowModal(false);
            setData(dataUser?.data);
            alert("کاربر با موفقیت ایجاد شد. ورود از طریق سامانه احراز هویت (OAuth) انجام می‌شود.");
        } else {
            const message =
                typeof dataUser?.data === "string"
                    ? dataUser.data
                    : dataUser?.data?.title || dataUser?.data?.message || "ایجاد کاربر ناموفق بود.";
            alert(message);
        }
    }
    const editAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)


        if (allValues.Password && !allValues.Password.match(check)) {
            setAllValuesError({ ...allValuesError, Password: true })
        }
        setSnipper(true)
        console.log(99)
        console.log(allValues)
        var res = allFull(allValues)


        console.log(res)
        if (res) {
            const dataUser = await axiosReq("user/UpdateUser", "put", {
                UserId: data?.userId,
                IsAdmin: allValues?.IsAdmin,
                Name: data?.name!=allValues?.Name? allValues.Name:"",
                Family: data?.family!=allValues?.Family? allValues.Family:"",
                Password: allValues?.Password,
                IsGozinesh: allValues?.IsGozinesh,
                IsFace: allValues?.IsFace,
                IsWordCloud: allValues?.IsWordCloud,
                IsCreateImage: allValues?.IsCreateImage,
                Supervisor: allValues?.Supervisor,
                Chatbot: allValues?.Chatbot


            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                console.log(77)
                console.log(dataUser)
              console.log(allValuesError)
                    alert(dataUser)
                    setShowModal(false)
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            console.log(obj)

            if (obj[o] == "" && o != "IsAdmin" && o != "IsGozinesh"
                && o != "IsFace" && o != "IsWordCloud" &&
                 o != "IsCreateImage" && o != "Password" && o != "Supervisor"
                 && o != "Chatbot" && o != "Username" && o != "Email" && o != "PhoneNumber"

            ) {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام</span>
                                <input
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    name="Name"
                                    placeholder="نام را اینجا بنویسید"
                                    value={allValues?.Name}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" />
                                {
                                    allValuesError.Name ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام خانوادگی</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام خانوادگی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Family"
                                    onChange={changeHandler}
                                    value={allValues?.Family}
                                    onInput={maxLengthCheck}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    maxLength={100} />
                                {
                                    allValuesError.Family ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام خانوادگی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            {title !== "ویرایش" ? (
                                <>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام کاربری</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    placeholder="نام کاربری OAuth"
                                    name="Username"
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    value={allValues?.Username}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                />
                                {allValuesError.Username ?
                                    <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                                        لطفا نام کاربری را وارد نمایید !
                                    </span>
                                    : null}
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ایمیل</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="email"
                                    placeholder="example@domain.com"
                                    name="Email"
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    value={allValues?.Email}
                                    onInput={maxLengthCheck}
                                    maxLength={256}
                                />
                                {allValuesError.Email ?
                                    <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                                        لطفا ایمیل معتبر وارد نمایید !
                                    </span>
                                    : null}
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">شماره موبایل</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    placeholder="مثال: 09121234567"
                                    name="PhoneNumber"
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    value={allValues?.PhoneNumber}
                                    onInput={maxLengthCheck}
                                    maxLength={20}
                                />
                                {allValuesError.PhoneNumber ?
                                    <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                                        لطفا شماره موبایل را وارد نمایید !
                                    </span>
                                    : null}
                            </div>
                                </>
                            ) : null}
                            <div className="col-span-2 mb-[10px]  flex flex-col">
                                                        <p className="text-[20px] font-IRANYekanBold mb-1">دسترسی های ادمین</p>
</div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ادمین</span>
                                <input onChange={(e) => setAllValues({ ...allValues, IsAdmin: e.target.checked })} checked={allValues.IsAdmin} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />


                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ناظر</span>
                                <input onChange={(e) => setAllValues({ ...allValues, Supervisor: e.target.checked })} checked={allValues.Supervisor} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />


                            </div>
                                   
      
                                <div className="col-span-2 mb-[10px]  flex flex-col">
                             <p className="text-[20px] font-IRANYekanBold mb-1">دسترسی های کاربر</p>
                             </div>
                                                   <div className="col-span-1 mb-[10px]  flex flex-col">

                                <span className="text-[15px] font-IRANYekanBold mb-1">چت باتها</span>
                                <input onChange={(e) => setAllValues({ ...allValues, Chatbot: e.target.checked })} checked={allValues.Chatbot} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />


                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">گزینش</span>
                                <input onChange={(e) =>
                                    setAllValues({ ...allValues, IsGozinesh: e.target.checked })
                                } checked={allValues.IsGozinesh} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />


                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">تشخیص چهره</span>
                                <input onChange={(e) => setAllValues({ ...allValues, IsFace: e.target.checked })} checked={allValues.IsFace} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />


                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ابرکلمه</span>
                                <input onChange={(e) => setAllValues({ ...allValues, IsWordCloud: e.target.checked })} checked={allValues.IsWordCloud} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />


                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ساخت عکس</span>
                                <input onChange={(e) => setAllValues({ ...allValues, IsCreateImage: e.target.checked })} checked={allValues.IsCreateImage} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />


                            </div>
                            {title !== "ویرایش" ? (
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">رمز عبور</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="password" placeholder="رمز عبور را اینجا بنویسید"
                                    name="Password"
                                    onChange={(e) => setAllValues({ ...allValues, Password: e.target.value })}
                                    value={allValues?.Password}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                />
                                {
                                    allValuesError.Password ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            رمز عبور هشت رقم و دارای حرف بزرگ و کوچک ، عدد و یکی از(.@?!*) می باشد!</span>
                                        :
                                        null
                                }
                            </div>
                            ) : null}


                        </div>
                        {title !== "ویرایش" ? (
                            <p className="text-[12px] font-IRANYekanNormal text-gray-600 mb-4">
                                نام کاربری، ایمیل و رمز عبور در سامانه احراز هویت (OAuth) ثبت می‌شوند؛ کاربر با همان نام کاربری و رمز از صفحه ورود وارد می‌شود.
                            </p>
                        ) : null}

                                <div className="flex justify-center">
                                    <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                                    <button onClick={() => title == "ویرایش" ? editAdmin() : addAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                                </div>
                        
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalAdmin;